var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-reactroot": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    fill: "none",
    d: "M12.84 4.01999H5.5C4.12 4.01999 3 5.13999 3 6.51999V19.52C3 20.9 4.12 22.02 5.5 22.02H18.5C19.88 22.02 21 20.9 21 19.52V6.51999C21 5.71999 20.62 4.99999 20.03 4.54999L20.04 4.55999C20.21 5.00999 20.31 5.49999 20.31 6.00999C20.31 8.21999 16.31 16 16.31 16C16.31 16 12.31 8.21999 12.31 6.00999C12.31 5.27999 12.5 4.60999 12.84 4.01999Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    d: "M12.49 7.10999L3.47998 20.99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    d: "M14.51 22.02L6.90002 15.72"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    d: "M19.17 21.93L8.55005 13.17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    fill: "none",
    d: "M20.3101 6.01C20.3101 8.23 16.3101 16 16.3101 16C16.3101 16 12.3101 8.23 12.3101 6.01C12.3101 3.79 14.1001 2 16.3101 2C18.5201 2 20.3101 3.8 20.3101 6.01Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 1,
    stroke: "currentColor",
    fill: "none",
    d: "M16.3101 6.48001C16.5862 6.48001 16.8101 6.25615 16.8101 5.98001C16.8101 5.70387 16.5862 5.48001 16.3101 5.48001C16.0339 5.48001 15.8101 5.70387 15.8101 5.98001C15.8101 6.25615 16.0339 6.48001 16.3101 6.48001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/MapIcon.855545301e76119bade1db1b2a34e551.svg";
export { ForwardRef as ReactComponent };